// extracted by mini-css-extract-plugin
export default {"main":"Main_main__NvyRo","add_image":"Main_add_image__iNIy4","support":"Main_support__mQcuS"};